import { useEffect, useState, useCallback } from 'react';
import { serviceRegistry } from '../services';
export function useService(serviceName) {
    const [service, setService] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const loadService = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const loadedService = await serviceRegistry.getService(serviceName);
            setService(loadedService);
        }
        catch (err) {
            const error = err instanceof Error ? err : new Error('Service load failed');
            setError(error);
            console.error(`Failed to load service ${serviceName}:`, error);
        }
        finally {
            setLoading(false);
        }
    }, [serviceName]);
    useEffect(() => {
        loadService();
    }, [loadService]);
    const reload = useCallback(() => {
        // Clear cached service and reload
        serviceRegistry.clearServices();
        loadService();
    }, [loadService]);
    return { service, loading, error, reload };
}
/**
 * Hook to check if a service is available without loading it
 */
export function useServiceAvailable(serviceName) {
    const [isAvailable, setIsAvailable] = useState(false);
    useEffect(() => {
        setIsAvailable(serviceRegistry.isAvailable(serviceName));
    }, [serviceName]);
    return isAvailable;
}
/**
 * Hook to get all registered services
 */
export function useRegisteredServices() {
    const [services, setServices] = useState([]);
    useEffect(() => {
        setServices(serviceRegistry.getRegisteredServices());
    }, []);
    return services;
}
//# sourceMappingURL=use-service.js.map